import { API_ROUTES } from '@/lib/constants';
import { createCrudService, createSubResourceGetter } from './crud.factory';
import type { Company, Contact, Deal, Activity, Note } from '@/types/table';

export const companyService = {
  ...createCrudService<Company>(API_ROUTES.COMPANIES),

  getContacts: createSubResourceGetter<Contact>(API_ROUTES.COMPANIES, 'contacts'),
  getDeals: createSubResourceGetter<Deal>(API_ROUTES.COMPANIES, 'deals'),
  getActivities: createSubResourceGetter<Activity>(API_ROUTES.COMPANIES, 'activities'),
  getNotes: createSubResourceGetter<Note>(API_ROUTES.COMPANIES, 'notes'),
};
